// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NdtK","colMin":"styles_colMin__3lxUM"};